// Visual Regressions Detection is a Playwright testing tool running on Circle-CI.
// It takes screenshots of pages from the scrubbed-db and pixelmatches them with baseline snapshots.
// If a commit results in layout changes on some pages, the Visual Regressions Testing will detect it.
//
// Some Popmenu Components render differently depending on the current date.
// Other components render differently by design (e.g. Animations, Videos).
// In order to make pixelmatch work it's necessary to disable such alterations.
// This is why this file exists.
// When visualRegressionsMode is true all Popmenu components must stop changing.
// All Popmenu consumer components must support that.

// Must remain null in production!!!
export let visualRegressionsMode: string | null = null;

const VISREG_ALLOWED_ENVS = ['production_local', 'development'];

export function setupVisualRegressionsMode(mode: string | null, env: string, dbType?: string) {
  visualRegressionsMode = mode;

  if (visualRegressionsMode != null) {
    console.warn(`[POPMENU] Visual Regressions Detection Mode on ${dbType} DB: ${visualRegressionsMode}. Env: ${env}. All content alterations are disabled. This message must never appear in production!!!`);

    if (typeof window !== 'undefined' && window.Sentry != null) {
      window.Sentry.captureMessage("Visual Regressions Mode and Sentry are running on the same page. It's likely a production environment. This is bad!!! Immediate action is required!!!");
    }
    if (!VISREG_ALLOWED_ENVS.includes(env)) {
      console.error(`[POPMENU] Visual Regressions are only working in ${VISREG_ALLOWED_ENVS.join(' and ')} environments, not in ${env}.`);
      visualRegressionsMode = null;
    }
  }
}

/**
 * Returns 'visreg-skip-waiting-for-skeletons' class name when visual regressions mode is active, otherwise returns undefined.
 * Use this to mark elements that should be ignored during visual regression testing (e.g. skeletons that are intended to remain visible after the page finishes loading).
 */
export function getVisregSkipClassName(): string | undefined {
  return visualRegressionsMode != null ? 'visreg-skip-waiting-for-skeletons' : undefined;
}
